export const DEFAULT_TAB_TITLE = 'Autodesk Construction Cloud';
